module.exports = __webpack_public_path__ + "img/zagrebacko-kazaliste-mladih-7231.b37b63e6.png";